import BuildingData from "@/http/data/building-data";

export default class BuildingState {
    buildings: BuildingData[] = [];
    isInitialized = false;
    selectedBuildingId: null|string = null;
}